/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2022 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

import React, { Component } from "react";
import { getMessage } from "utils/TranslationUtil";
import CustomIcon from "dc-preview-utils/src/components/CustomIcon";
import { modernViewerDropinContext } from "constants/enums";
import downloadIcon from "dc-icons/viewer2021/SDC_Download_18_N.svg";
import downloadIconMobile from "dc-icons/viewer2021/Web_Mobile/SDC_Download_22_N.svg";
import * as stores from "stores";
import { downloadAssetFromDocApi } from "utils/DownloadUtility";
import { providers } from "dc-core";

class DownloadBootstrap extends Component {
  getLabel = () => getMessage("common.download");

  getIcon = opts =>
    opts && opts.context === modernViewerDropinContext.MODERN_MOBILE_OVERFLOW_MENU
      ? () => <CustomIcon url={downloadIconMobile} />
      : () => <CustomIcon url={downloadIcon} />;

  id = "download-file";

  initializeAction = opts => {
    opts.showCallback(true);
  };

  executeAction = async () => {
    await downloadAssetFromDocApi(stores, { triggeredFrom: "MobileModernViewerOverflowMenu" });
    providers["tools-board-provider"]().then(toolsBoardProvider => toolsBoardProvider.reset());
  };

  render() {
    return null;
  }
}

export default DownloadBootstrap;
